<template>
  <div class="animated fadeIn container-fluid top-padding">
    <div class="row">
      <div class="col-xs-12">
        <div class="text-center">
          <br />
          <h2>Welcome to the Highlight Film Test Stand Portal</h2>
          <br />
          <br />
          <br />
          <h5>This portal allows you to review the data, create graphs and analyze results of film tests from across multiple testing systems.</h5>
          <br />
          <br />
        </div>
        <div class="row img-row">
          <div class="col-sm-4 text-wrapper text-right">
            <div>
              Data allows you to select the date range to view your test results.
            </div>
          </div>
          <div class="col-sm-8 img-wrapper">
            <div>
              <img src="static/img/dashboard1.jpg" width="100%" />
            </div>
          </div>
        </div>

        <div class="row img-row">
          <div class="col-sm-8 img-wrapper">
            <div>
              <img src="static/img/dashboard3.jpg" width="100%" />
            </div>
          </div>
          <div class="col-sm-4 text-wrapper">
            <div>
              Graphs allow you to create graphs within a specific data and time range encompassing the range of film tests
            </div>
          </div>
        </div>

        <div class="row img-row">
          <div class="col-sm-4 text-wrapper text-right">
            <div>
              You can also view graphs for multiple tests of the same type in a single graph.
            </div>
          </div>
          <div class="col-sm-8 img-wrapper">
            <div>
              <img src="static/img/dashboard3.jpg" width="100%" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.img-row {
  margin-top: 30px;

  .text-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    > div {
      font-size: 1.3em;
      padding: 20px;
    }
  }

  .img-wrapper {
    > div {
      margin: 15px;
      border: #c0c0c0 1px solid;
      padding: 15px;
    }
  }
}
</style>

<script>
export default {
  name: 'dashboard',
  components: {
  }
}
</script>



// WEBPACK FOOTER //
// Dashboard.vue?563d8937